import React from 'react'
import TableLayout from '../../components/TableLayout'
import Search from '../../components/Search'
import { Col, Row, Form } from 'antd'

const CashdrawalReasonsContainer = props => {

    const columns = [
        {
            title: 'Motivo',
            dataIndex: 'name',
            sorter: true,
            filtered: true,
        },
        {
            title: 'Fecha de Creación',
            dataIndex: 'created_at',
            sorter: true,
            filtered: true,
        },
    ]

    return (
        <>
            <TableLayout
                title="Razones de retiro de efectivo"
                columns={columns}
                resource={`cash-withdrawal-reasons`}
                actions={['create']}
            />
        </>
    )
}

export default CashdrawalReasonsContainer
